import React from 'react';

const Information = () => {
    return <div>Information Component</div>;
};

export default Information;
